<div [ngClass]="dialogSize" class="cdw-confirmation-dialog">
  <!-- Header -->
  <div class="dialog-header" [style.background-color]="data.titleBackgroundColor || null">
    <h2
      class="dialog-title"
      [style.color]="data.titleColor || null"
      [style.font-family]="data.titleFontFamily || null"
      [style.font-size]="data.titleFontSize || null"
      [style.font-weight]="data.titleFontWeight || null"
    >{{ data.title }}</h2>
    <button
      *ngIf="!data.hard"
      type="button"
      class="dialog-close-button"
      (click)="onDismiss()"
      aria-label="Close dialog"
      [style.color]="data.titleColor || null"
    >
      <lib-cdw-icon icon="close"></lib-cdw-icon>
    </button>
  </div>

  <!-- Content - Default Layout (centered icon) -->
  <div *ngIf="!isWarningBoxLayout" class="dialog-content" [class.no-icon]="data.hideIcon" [style.padding]="data.contentPadding || null">
    <div *ngIf="!data.hideIcon" class="dialog-icon-container">
      <lib-cdw-icon [icon]="dialogIcon" [ngClass]="dialogIconClass"></lib-cdw-icon>
    </div>
    <div
      class="dialog-message"
      [style.font-family]="data.fontFamily || null"
      [style.color]="data.messageColor || null"
      [style.font-size]="data.messageFontSize || null"
      [style.font-weight]="data.messageFontWeight || null"
    >
      <span *ngIf="!data.htmlMessage">{{ data.message }}</span>
      <span *ngIf="data.htmlMessage" [innerHTML]="data.htmlMessage"></span>
      <a
        *ngIf="data.linkUrl"
        [href]="data.linkUrl"
        target="_blank"
        class="dialog-link"
        [style.color]="data.linkColor || null"
      >{{ data.linkText || 'Learn more' }}</a>
    </div>

    <!-- Confirmation Input -->
    <div *ngIf="data.requireInputConfirmation" class="confirmation-input-container">
      <input
        *ngIf="!data.useTextarea"
        type="text"
        [(ngModel)]="confirmationInput"
        class="confirmation-input"
        placeholder="{{ data.inputLabel || data.requiredText }}"
      />
      <textarea
        *ngIf="data.useTextarea"
        [(ngModel)]="confirmationInput"
        class="confirmation-textarea"
        [rows]="data.textareaRows"
        [placeholder]="data.textareaPlaceholder"
      ></textarea>
    </div>
  </div>

  <!-- Content - Warning Box Layout (left icon with bordered box) -->
  <div *ngIf="isWarningBoxLayout" class="dialog-content dialog-content-warning-box" [style.padding]="data.contentPadding || null">
    <div class="warning-box">
      <div class="warning-box-icon">
        <lib-cdw-icon [icon]="dialogIcon" [ngClass]="dialogIconClass"></lib-cdw-icon>
      </div>
      <div
        class="warning-box-message"
        [style.font-family]="data.fontFamily || null"
        [style.color]="data.messageColor || null"
        [style.font-size]="data.messageFontSize || null"
      >
        <span *ngIf="!data.htmlMessage">{{ data.message }}</span>
        <span *ngIf="data.htmlMessage" [innerHTML]="data.htmlMessage"></span>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="dialog-actions" [class.no-border]="data.hideActionsBorder">
    <!-- Checkbox on the left (if enabled) -->
    <div *ngIf="data.showDontShowAgainCheckbox" class="dialog-checkbox">
      <lib-cdw-checkbox
        [checked]="dontShowAgain"
        (checkedEmitter)="dontShowAgain = $any($event).checked"
        [style.font-family]="data.fontFamily || null"
      >
        {{ data.dontShowAgainText }}
      </lib-cdw-checkbox>
    </div>

    <!-- Spacer to push buttons to the right -->
    <div class="flex-grow"></div>

    <!-- Buttons on the right -->
    <lib-cdw-button
      *ngIf="showCancelButton"
      (buttonClick)="onCancel()"
      level="secondary"
      mode="standard"
    >
      {{ data.cancelText }}
    </lib-cdw-button>
    <lib-cdw-button
      (buttonClick)="onConfirm()"
      [level]="confirmButtonColor"
      mode="standard"
      cdkFocusInitial
      [disabled]="isConfirmDisabled()"
      [ngClass]="{ 'button-disabled-block-cursor': isConfirmDisabled() }"
    >
      {{ data.confirmText }}
    </lib-cdw-button>
  </div>
</div>
